/* if you modify this file, please remove this line then fix eslint errors. */ /* eslint-disable */
import { getUserById } from '../../state/users/selectors';

function getCurrentUser_(state) {
  return state.currentUser;
}

export function getCurrentUserId(state) {
  const currentUser = getCurrentUser_(state);
  if (!currentUser || !currentUser.id) {
    return null;
  }
  return currentUser.id.toString();
}

export function getCurrentUser(state) {
  const currentUserId = getCurrentUserId(state);

  if (!currentUserId) {
    return null;
  }

  return getUserById(state, currentUserId);
}

export default {
  getCurrentUserId,
  getCurrentUser,
};
